import { Link } from "react-router-dom";
import { TRABrandLockup } from "../../components/brand";
import { cn } from "../utils/cn";
import styles from "./shell.module.css";

/**
 * Canonical platform brand mark for AppShell / branded chrome.
 * One lockup treatment — do not invent alternate logos.
 *
 * @param {{
 *   to?: string;
 *   size?: 'sm' | 'md' | 'header' | 'lg';
 *   className?: string;
 *   asLink?: boolean;
 * }} props
 */
export default function ShellBrandHeader({
  to = "/",
  size = "header",
  className,
  asLink = true,
}) {
  const lockup = <TRABrandLockup size={size === "header" ? "header" : size} />;
  if (!asLink) {
    return (
      <div className={cn(styles.headerBrand, className)} data-tra-brand-chrome>
        {lockup}
      </div>
    );
  }
  return (
    <Link
      to={to}
      className={cn(styles.headerBrand, className)}
      data-tra-brand-chrome
      aria-label="TheRallyAlly home"
    >
      {lockup}
    </Link>
  );
}
